export default {
  aggregates: {
    aggregated: 'Natiijooyinka isku dhafka ah',
    aggregatedDate: '{startDate} - {fromDate}',
    ago: 'kahor',
    from: 'ka socda',
    since: 'ilaa',
    unit: {
      DAY: 'maalin/maalmood',
      MONTH: 'bil/bilo',
      YEAR: 'sanad/sanado'
    },
    untilNow: 'ilaa iyo hadda'
  },
  categoryDetails: {
    average: 'Cadadka celceliska ah waa {average}. {benchmark}',
    chartLabel: {
      noLabel: 'Maya',
      yesLabel: 'Haa'
    },
    description:
      "Tani waxay muujinaysaa sida loo qaybiyo jawaabaha kooxdu ka bixiso dhammaan su'aalaha ku jira qeybta.",
    hideOwnAnswers: 'Qari jawaabahaaga gaarka ah',
    noResponses: 'Ma aadan bixin jawaabo',
    notParticipating: 'Adi nafsan ahaantaada ma aadan bixin jawaabahaaan.',
    numberOfPeople: 'Jawaab bixiyaasha',
    sensitiveQuestion: 'Adiga kaliya aad arki karta ka maamule ahaan.',
    showFollowUpQuestions: "Muuji su'aalaha dabagalka ah",
    toggleButton: {
      overview: 'Guudmar',
      questions: "Su'aalo"
    },
    tooltip: {
      barValue: 'midna | 1 qof | {count} dad',
      barValueAnswers: 'midna | 1 jawaab | {count} jawaabo'
    },
    workWith: 'Sida loola shaqeeyo {categoryName}',
    yourResponse: 'Waxaad ku jawaabtay:'
  },
  error: {
    couldNotLoadAggregates: 'Lama soo saari karo natiijooyinka isku dhafka ah.',
    couldNotLoadResults: 'Lama soo saari karo natiijooyinka.',
    networkError:
      'Cilad ayaa ku imaatay soo bixinta xogta interneetka. Ma leedahay xiriir shaqo?'
  },
  errors: {
    status: {
      InternalServerError:
        'Wax ka qaladay serverka, fadlan taageerada la xiriir haddii tani sii joogto',
      UnknownError: 'Khalad la ogan ayaa dhac'
    }
  },
  freetext: {
    loadResponses: 'Ma aadan bixin jawaabo',
    noFreeTextQuestions:
      "Marka aad su'aalo qoraalka xor ah ku hayso baareedkaaga, waxaad awood doontaa inaad arko dhamaan jawaabaha halkan.",
    notEnoughResponses: 'Jawaabta ma filan.',
    responses: 'Jawaabo ma jawaab| {tiro} jawaab | {tiro} jawaabaha'
  },
  general: {
    add: 'Kudar',
    cancel: 'Jooji',
    entireOrganization: 'Ururka dhammaan',
    ok: 'Okay'
  },
  groupsComparison: {
    averageForItem:
      "{value} waa celceliska guud ee la xariira su'aalaha {title}. {compareToBenchmark}",
    currentValue: 'Cadadka hadda',
    filter: {
      findGroups: 'Raadi kooxaha',
      shouldExportWithHierarchy: 'Ku jira kooxaha hoos'
    },
    loadMore: 'Soo bixi kuwo badan',
    loadMoreInGroup: 'Hoos dheeraad ah hoos {GroupName}',
    noone: 'Majiro mid soo jawaabay',
    noResults:
      'Wali kooxdaan ma bixin jawaabo badan. {numberOfUsersThatHaveRespondedText}.',
    noResultsResponded: 'ayaa jawaabay',
    nps: 'Dhibcaha Dhiirigelinta Shabakada',
    nps_detractors: 'Hoos u dhigayaasha',
    nps_passives: 'Aqbalida',
    nps_promoters: 'Dhiirigeliyaasha',
    questions: "Su'aalaha qaybta",
    showTrend: 'Muuji isbadelka',
    violationsIn:
      'Waxaa la bixiyay warbixino la xariira in xadgudubyo ka dhex dhaceen {groupName}. Fadlan la xariir waaxda shaqaalaha ee kuu sheegi karta xog dheeraad ah kaana caawin karta inaad xaliso cilada jirta.'
  },
  loading: {
    error: {
      link: 'Mar labaad iskuday'
    }
  },
  navbar: {
    currentSurveys: 'Xog aruurinta hadda',
    myActivities: 'Ficilada',
    overview: 'Guudmar',
    welcome: 'Soo dhawaaw'
  },
  page: {
    results: 'Dhammaan natiijooyinka'
  },
  resultDetails: {
    backToResults: 'Dib u laabo',
    exportData: 'Soo Deji',
    exportModal: {
      includeSensitiveQuestions: "Ku dar su'aalaha xasaasiga ah",
      loadingMessage:
        'U diyaarinta xogta in lasoo dejiyo, tani waxay qaadan doonaa waqti yar.',
      saveAsExcelButton: 'Excel',
      saveAsPowerPointButton: 'PowerPoint'
    },
    notes: {
      status: {
        unsaved: 'Badbaadinta dhowaan...'
      }
    },
    tagDetails: {
      color: {
        alerts: {
          notEnoughResponses:
            'Majiraan jawaabo ku filan in lasoo bandhigto natiijooyinka halkii isticmaalaba'
        },
        description: {
          high: 'Halka qof ee bixiyay jawaab si natiijadiisa celceliska u noqoto cagaar.|Waxaa jira {count} qof oo bixiyay jawaabo si natiijooyinkooda celceliska u noqdaan cagaar.',
          low: 'Halka qof ee bixiyay jawaab si natiijadiisa celceliska u noqoto cassaan.|Waxaa jira {count} qof oo bixiyay jawaabo si natiijooyinkooda celceliska u noqdaan cassaan.',
          medium:
            'Waxaa jira halk qof ee bixiyay jawaab si natiijadiisa celceliska u noqoto jaalle.|Waxaa jira {count} dad bixiyay jawaabo si natiijooyinkooda celceliska u noqdaan jaale.'
        },
        title: 'Qofna|Hal qof|{count} dad'
      },
      currentValue: {
        equalsToBenchmarkValue:
          'Natiijadaadu waxay la mid tahay tan Pulsᐩ benchmark® ee la xariirta {title}.',
        higherThanBenchmarkValue:
          'Natiijadaadu waxay {benchmarkDiff} ka sareeysaa tan the Pulsᐩ benchmark® ee la xariirta {title} oo ah {benchmarkValue}. Hagaag!',
        lowerThanBenchmarkValue:
          'Waxaad {benchmarkDiff} ka hooseysa tan Pulsᐩ benchmark® ee la xariirta {title} ahna {benchmarkValue}',
        percentagePoints: 'dhibcood boqolada'
      },
      enps: {
        button: {
          description:
            'Waxaa laguu diri doonaa iskaashadaheena, EQI, oo uruuriya xogta bartilmaameedka tiro badan oo ururo ah oo ku siinaya aragti faahfaahsan oo ku saabsan dhibcahaaga eNPS.',
          title: 'La barbardhig natiijadaada eNPS tan ururada kale'
        }
      },
      toggleButton: {
        history: 'Taariikhda',
        overview: 'Guudmar'
      }
    }
  },
  results: {
    aggregated: 'Lagu dhacay',
    chooseSurvey: 'Dooro baaddaan',
    finished: 'La dhameeyay',
    published: 'Soo socda'
  },
  resultsmessages: {
    disclaimer:
      'Pulsᐩ AI waxa uu adeegsadaa AI soo-saar leh wuxuuna samayn karaa khaladaad.',
    error: {
      generic:
        'Uh, oh... wax ma shaqeyn sida la filayaa. Fadlan isku dayo inaan dib u qabsado bogga.',
      notEnoughResults:
        'Ma natiijayo in la hadlo. Fadlan doorto koox duwan ama baahan si aad u isticmaalaan PulsAI.'
    },
    moreInfo: 'Barro sidii loo adeegsado PulsAI oo hogaamiye',
    moreInfoLink: 'https://www.puls-solutions.com/help/#/section/1/articles/10',
    placeholder: "Su'aal ka weydiiyay natiijada...",
    reload: 'Dib u laad bogga',
    report: 'Dhibaatada Warbixin',
    send: 'Dir',
    suggestionHeader:
      "Halkan waa talooyin qaar ee su'aalaha aad weydiin kartaan:",
    suggestions: {
      groupsComparison: {
        1: 'Kooxaha waa aan saaran diiradda?',
        2: "Ma jira su'aal ah oo kooxaha badan ay ku shaqeeyaan?",
        3: 'Kooxaha taasi muujinaysa xaafadaha',
        4: 'Kooxaha ay leeyihiin jiraan fiican?',
        5: 'Kooxaha ee si xun ah u taagan?',
        6: 'Kooxaha ee u baahan tahay darkeeyga?',
        7: 'Maxaan ugu horreeyey sameeyaa?'
      },
      overview: {
        1: 'Maxaan la sameeyaa natiijadeena?',
        2: 'Sidee aan arrintan u soo bandhigin kooxkeyga?',
        3: 'Guud ahaan, natiijada maxay u muuqda?',
        4: 'Maxay tahay 3-tallaha ugu sarreeya ee aan qaadanno?',
        5: 'Maxaan hormariyo karaa hoggaamineyda?',
        6: 'Halcelis maxay aan haynaa?',
        7: 'Maxaa dhici karaa haddii aan falin?',
        8: 'Maxaan tahay in aan u horeysay?',
        9: 'Maxay tahay saaraadinta kooxkeyga?'
      }
    },
    title: 'Pulse AI'
  },
  resultsPerAttribute: {
    attributes: {
      all: {
        title: 'Qofk kasta'
      }
    }
  },
  sections: {
    resultsForSurvey: {
      tabs: {
        compare: {
          title: 'Isbarbar'
        },
        export: {
          title: 'Soo Deji'
        },
        freetext: {
          title: 'Qoraal xor ah'
        },
        results: {
          title: 'Natiijooyinka baad'
        }
      }
    }
  },
  segmentedDetails: {
    notEnoughResponses:
      'Macquul ma ahan in la muujiyo xogaha ayadoon halis la gelineyn in la dhumiyo qarsoodiga xogta.',
    others: 'Kale | Dadka kale',
    tooltip: {
      barValue: '{numberOfPeople} {segment}'
    }
  },
  sidebar: {
    administration: 'Maamulka',
    currentSurveys: 'Xog aruurinta hadda',
    dashboard: 'Dhaashboodhka',
    help: 'Caawimaad',
    logOut: 'Ka bax',
    myActivities: 'Tallaabooyinkayga',
    ourResults: 'Natiijooyinkeena'
  },
  topbanner: {
    preview: {
      body: 'Waxaad hadda eegaynaa nooca cusub ee aragtida natiijada Pulsoo leh horumar badan! Haddii aad kulmaan wax aan shaqeyn sida waa in, ama haddii aad fasalin leeyahay, fadlan naga ogayn! Waxaad sidoo kale dib u bedeli kartaa nooca hore haddii aad rabto.',
      header: 'Nooca cusub!'
    }
  },
  trendArrow: {
    category: {
      tooltip: {
        trend_decreased:
          'Muddo waqtiga {StartDate} - {EndDate} natiijada waxa uu yareeyay {categoryName}.',
        trend_increased:
          'Muddo waqtiga {startDate} - {EndDate} natiijada ayaa kordhay {categoryName}. Iyo shaqada wanaagsan!',
        trend_same:
          'Natiijada waxa uu isla ka hadlay {categoryName} muddo waqtiga {startDate} - {endDate}.'
      }
    },
    noTrend: 'Majirto xog aruurin hore si loola barbardhigo.',
    tag: {
      tooltip: {
        nps_trend_decreased:
          'Marka lala barbardhigo xog aruurintii hore ee {oldSurveyDate} natiijooyinku waxay hoos u dhaceen {changeInPercent}% marka la eego {tagName}.',
        nps_trend_increased:
          'Marka lala barbardhigo xog aruurintii hore ee {oldSurveyDate} natiijooyinku waxay kor u kaceen {changeInPercent}% marka la eego {tagName}.',
        nps_trend_same:
          'Natiijadu waa iska ag dhowdahay ({changeInPercent}% isbadel) marka la eego {tagName} ilaa iyo xogta aruurinta la sameeyay {oldSurveyDate}.',
        trend_decreased:
          'Muddo waqtiga {StartDate} - {EndDate} natiijada waxa uu yareeyay {tagName}.',
        trend_increased:
          'Muddo waqtiga {startDate} - {EndDate} natiijada ayaa kordhay {tagName}',
        trend_same:
          'Natiijada waxa uu isla ka hadlay {categoryName} muddo waqtiga {startDate} - {endDate}.'
      }
    }
  },
  utilityBar: {
    group: 'Kooxda',
    segment: 'Qeybta',
    survey: 'Sawirka'
  },
  widgetActionsSummary: {
    labels: {
      peopleThatSelectedAnAction: 'Tirada dadka u xulay ugu yaraan tallaal',
      totalActions: 'Wadarta tirada falalka la doortay'
    },
    title: 'Fallada kooban'
  },
  widgetAlert: {
    actions: {
      saved: 'Mahadsanid, hawsha waa la seyf gareeyay.'
    },
    links: {
      tooltip: 'Lifaaqyadu waxay ku furmayaan shaashad cusub'
    },
    notEnoughData: 'Majiraan wax lagu muujiyo halkaan hadda.'
  },
  widgetCategoriesBars: {
    notEnoughResponses:
      'Wali majiraan jawaabo ku filan in lagu muujiyo halkaan.',
    title: 'Qaybaha',
    tooltip: {
      value:
        "Kani waa celceliska cadadka dhamaan jawaabaha la xariira su'aalaha {categoryName} ee ay ka jawaabeen dadka kamidka ah {groupName}."
    }
  },
  widgetGroupActions: {
    allCategories: 'Kamidka ah dhammaan qaybaha',
    freeText: {
      alert: {
        noResults: 'Waxba lama helin. Iskuday inaad qorto wax kale.',
        typeMore: 'Qor xoogaa badan'
      },
      filterField: {
        placeholder: 'Qor si aad u hesho faallooyinka'
      },
      numberOfComments: '{numberOfComments} faalllooyin'
    },
    noActions: 'Majiraan tallaabooyin la muujin karo.',
    noActionsSelectedInCategory: 'Majiraan tallaabooyin la doortay',
    otherActions: 'Tallaabooyinka gaarka ah',
    people: 'midna | {count} qof | {count} dad',
    peopleSelectedActions:
      'Oo {peopleResponded} qof ayaa bixiyay jawaab kaliya 1 kamid ahna ayaa ugu u yaraan doortay hal ficil ({percentage}%)| Oo {peopleResponded} qof ayaa bixiyay jawaabo, {count} qof ayaa doortay ugu yaraan hal ficil ({percentage}%)',
    title: 'Tallaabooyinka dadka ee la doortay {groupName}',
    tooltip: {
      numberOfPeopleChoseActions:
        '1 qof ayaa doortay tallaabadaan | {count} qof ayaa doortay tallaabadaan'
    }
  },
  widgetGroupPriorities: {
    description:
      'Kuwaan waa aagaga inta ugu badan ay tahay in awooda la saaro waqti xaadirkaan, sida laga soo xigtay ka qaybgalayaasha xog aruurinta.',
    freeTextResponses: 'Muuji jawaabaha qoraal bilaashka ah',
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887214144',
        title: 'Sida loo horumarinayo kooxdaaga Puls'
      }
    },
    noPriorities: 'Majiraan kala horey ay doorteen ka qaybgalayaashu.',
    people: 'midna | {count} qof | {count} dad',
    thinkImportant: ' ka fakar "{category}" ayaa ah kan ugu muhiimsan',
    title: 'Mudnaanta dadka {groupName}'
  },
  widgetNotImplemented: {
    content: 'Aan wali la hirgelin'
  },
  widgetSurveyInfo: {
    endDate: 'Taariikhda dhammaadka:',
    noone: 'Majiro mid soo jawaabay',
    notEnoughResponses: {
      aggregate:
        'Dadka ma filan oo ka jawaabay xilliga waqtiga si loo muujino natiijada.',
      completed:
        'Dad kama filan ah oo ka jawaabay baareedka si loo muujino natiijada.',
      published:
        'Weli ma filan dad ah oo ka jawaabay baareedka si loo muujino natiijada.'
    },
    participation: {
      title: 'Qeybgalka'
    },
    startDate: 'Taariikhda billoowga:',
    status: {
      completed:
        'Xog aruurinta la dhameeyay! Waxaa jira natiijooyin kama danbeys ah.',
      published: 'Xog aruurintu wali waa socotaa. Natiijooyinku waa hordhac.'
    },
    usersInvited: 'Dadka la casuumay:',
    usersResponded: 'Dadka jawaabaha bixiyay:'
  },
  widgetTagsDonuts: {
    description: {
      all: 'Kuwani waa natiijooyinkii ugu dambeeyay ee {groupName}.'
    },
    notEnoughResponses:
      'Wali majiraan jawaabo ku filan in lagu muujiyo halkaan.',
    title: {
      company: 'Dhammaan {organizationName}'
    },
    tooltip: {
      enps_description:
        'eNPS waxaa laga soo gaabiyay Employee Net Promoter Score (Dhibcaha Dhiirigelinta Shabakadda Shaqaalaha) waxaana lagu cabiraa qaabka shaqaaluhu u doonayaan inay u doodaan shaqaaleysiinta shirkadooda.',
      nps_description:
        'NPS waxaa laga soo gaabiyay Net Promoter Score (Dhibcaha Dhiirrigelinta Shabakadda) waxaana lagu oggaadaa qaabka ay u badan inay dadku dadka kale wax ku dhiirigeliyaan.',
      nps_detractors: 'Hoos u dhigayaasha',
      nps_passives: 'Aqbalida',
      nps_promoters: 'Dhiirigeliyaasha',
      value:
        "Kani waa celceliska cadadka dhamaan jawaabaha la xariira su'aalaha {tagName} ee ay ka jawaabeen dadka kamidka ah {groupName}."
    }
  },
  widgetTagsTrends: {
    title: '{tagNames} muddo kadib',
    twoTags: '{tag1} iyo {tag2}'
  }
}
